/**
 * TopLocationsTable — Section 5: Top 10 Locations by Total Alerts (7-day breakdown).
 */

import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { formatDate, getToday } from '../../../../libs.jsx';

const TopLocationsTable = ({ data }) => {
    const dayHeaders = useMemo(() => {
        const headers = [];
        for (let i = 7; i >= 1; i--) {
            headers.push({
                key: `day${7 - i}`,
                label: formatDate(getToday(-i)),
            });
        }
        return headers;
    }, []);

    if (!data || data.length === 0) return null;

    return (
        <div className="ex-section">
            <h3 className="ex-section__title">Top 10 Locations by Total Alerts (Last 7 Days)</h3>
            <div className="ap-table-container">
                <div className="dp-table-wrap">
                    <table className="dp-table">
                        <thead className="dp-thead">
                            <tr>
                                <th scope="col" className="ap-th"><div className="ap-th__content"><span>Area</span></div></th>
                                <th scope="col" className="ap-th"><div className="ap-th__content"><span>Resident</span></div></th>
                                {dayHeaders.map((d) => (
                                    <th key={d.key} scope="col" className="ap-th" style={{ textAlign: 'center' }}>
                                        <div className="ap-th__content" style={{ justifyContent: 'center' }}><span>{d.label}</span></div>
                                    </th>
                                ))}
                                <th scope="col" className="ap-th" style={{ textAlign: 'center' }}>
                                    <div className="ap-th__content" style={{ justifyContent: 'center' }}><span>Total</span></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, idx) => (
                                <tr key={idx} className="dp-tr">
                                    <td className="dp-td">
                                        {row.area_id ? (
                                            <Link to={`/profiles/area/${row.area_id}`} className="ar-link">{row.area_name || '--'}</Link>
                                        ) : (row.area_name || '--')}
                                    </td>
                                    <td className="dp-td">
                                        {row.resident_id ? (
                                            <Link to={`/profiles/resident/${row.resident_id}`} className="ar-link">{row.resident_name || '--'}</Link>
                                        ) : (row.resident_name || '--')}
                                    </td>
                                    {dayHeaders.map((d) => (
                                        <td key={d.key} className="dp-td" style={{ textAlign: 'center' }}>
                                            {row[d.key] != null ? row[d.key] : 0}
                                        </td>
                                    ))}
                                    <td className="dp-td" style={{ textAlign: 'center', fontWeight: 600 }}>
                                        {row.total != null ? row.total : 0}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopLocationsTable;
